
import axios from '../../config/axiosConfig';
import { GET_BILL_ADJUSTMENTS, SET_BILL_ADJUSTMENTS, BILL_ADJUSTMENT_REQUEST, BILL_ADJUSTMENT_REQUEST_FAILURE, RESET_BILL_ADJUSTMENTS } from '../types';

export const getBillAdjustments = (data, page, limit) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BILL_ADJUSTMENT_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, ...data, page, limit };
            return axios.get('/bill-adjustment/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BILL_ADJUSTMENTS, payload: response.data });
                } else {
                    dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Get Bill Adjustments failed.' });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBillAdjustments = (billAdjustment) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BILL_ADJUSTMENT_REQUEST });
            return axios.post('/bill-adjustment/add', billAdjustment,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: SET_BILL_ADJUSTMENTS, payload: response.data });
                } else {
                    dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Bill Adjustments create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBillAdjustments = (billAdjustment) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BILL_ADJUSTMENT_REQUEST });
            return axios.put('/bill-adjustment/update', billAdjustment,
                { params: { userId: auth.user?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: SET_BILL_ADJUSTMENTS, payload: response.data });
                    } else {
                        dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Bill Adjustments update failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const resetBillAdjustments = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_BILL_ADJUSTMENTS });
    };
};

export const setBillAdjustments = (data) => {
    return async (dispatch) => {
        dispatch({ type: SET_BILL_ADJUSTMENTS, payload: data });
    };
};

export const getBankPaymentUnAdjByAccountId = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BILL_ADJUSTMENT_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get("/bank-receipt/get-unadj-by-account-bank-payment", { params }).then((response) => {
        console.log('response>>>actions>>>', response);

        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankUnAdjByAccountId = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BILL_ADJUSTMENT_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get("/bank-receipt/get-unadj-by-account-bank-receipt", { params }).then((response) => {
        console.log('response>>>actions>>>', response);

        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};